<!--
create by melody on 2018/12/7
description:长传文件
-->
<template>
    <div class="hdp-uf" style="margin-left:50px;width:70%;">
        <iframe :src="exportUrl" style="display: none"></iframe>
       <!--  <a id="target" style="display: none" :href="exportUrl"></a> -->
        <el-input :placeholder="$t('m.onlyTemplate')" :disabled="true" style="width:30%;" v-model="uploadFileUrl"></el-input>
        <div class="hdp-uf">
            <el-upload
                class="upload-demo"
                action=""
                :auto-upload="false"
                :on-change="actionChange"
                :show-file-list='false'>
                <el-button class="file-btn" type="primary" plain> {{$t('m.chooseFile')}} </el-button>
            </el-upload>
        </div>
        <el-button class="file-btn" type="primary" plain @click="doUpLoadFile()" :disabled="isDisableUpLoadAction" v-loading.fullscreen.lock="uploading"> {{$t('m.uploadFile')}} </el-button>
        <!-- <el-button class="file-btn" type="primary" v-else plain @click="doUpLoadFile()" icon="el-icon-loading" :disabled="isDisableUpLoadAction"> 上传中 </el-button> -->
        <el-dialog
            :title="$t('m.uploadErr')"
            v-if="uploadDialogVisible"
            :visible.sync="uploadDialogVisible"
            width="30%">
            <div class="dialog-content">
                <el-table
                    :data="tableErrorData"
                    highlight-current-row
                    style="width: 100%">
                    <el-table-column
                      type="index">
                    </el-table-column>
                    <el-table-column
                      property="order"
                      :label="$t('m.errOrder')">
                    </el-table-column>
                    <el-table-column
                      property="description"
                      :label="$t('m.errDescription')">
                    </el-table-column>
                </el-table>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="uploadDialogVisible = false">{{$t('m.cancel')}}</el-button>
                <el-button type="primary" @click="validData()">{{$t('m.exportErr')}}</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
export default {
    props: ['uploadUrl'],
    data() {
        return {
            uploadDialogVisible: '',
            uploadFileUrl: '',
            isDisableUpLoadAction: true,
            errorId: '',
            exportUrl: '',
            uploading: false,
        }
    },
    methods: { 
        doUpLoadFile(){
            this.uploading = true
            this.isDisableUpLoadAction = true            
            this.$commonFunc.commonRequest('upLoadFile', this.uploadUrl, 'uploadedFile', {uploadedFile: this.uploadedFile})
            .then(res=>{
                this.uploading = false
                this.isDisableUpLoadAction = false   
                if(!res.obj) {
                    this.$message.success(this.$t('m.uploadSuccess'));
                    this.$emit('successMethod')
                } else {
                    this.tableErrorData = []
                    let obj = JSON.parse(res.obj.errorInfo)
                    for (var key in obj) {
                        this.tableErrorData.push({'order': key, 'description': obj[key]})
                    }
                    this.errorId = res.obj.errorId
                    this.uploadDialogVisible = true
                }
            })
            .catch(res=>{
                this.uploading = false
                this.isDisableUpLoadAction = false  
                if (res.code == '00002' && res.message[0] == '{' ) {
                    let obj = JSON.parse(res.message)
                    this.tableErrorData = []
                    for (var key in obj) {
                        this.tableErrorData.push({'order': key, 'description': obj[key]})
                    }
                    this.uploadDialogVisible = true
                } else {
                    this.$message.error(res.message)
                }
            })
        },
        actionChange(param) {
            let res = this.$commonFunc.checkFileTypeAndSize(param)
            if(res) {
                this.$message.error(res)
                return
            }
            this.uploadFileUrl = param.name
            this.uploadedFile = param.raw
            this.isDisableUpLoadAction = false
        },
        validData() {
            this.$commonFunc.commonRequest('get', '/export/uploaded/error/validData', 'uploadedValidData', {errorId: this.errorId})
            .then(res=>{
                if(!res.obj) {
                    this.exportUrl = (localStorage.getItem('apiServerHost') ? 'http://'+localStorage.getItem('apiServerHost') : this.$config.APISERVER.host)
                            + '/export/uploaded/error/export?errorId=' + this.errorId
                            + '&lap-cookie-token=' + this.$store.state.userInfo.userInfoObj.token
                            + '&t=' + Date.now()
                            console.log(this.exportUrl, 118)
                    this.uploadDialogVisible = false   
                    // setTimeout(()=>{
                    //     document.getElementById("target").click()
                    // }, 1000)
                } else {
                    this.$message.error(res.obj)
                }
            })
            .catch(res=>{
                this.$message.error(res.message)
            })
        }
    },
    mounted() {

    }
}
</script>
<style scoped>
.file-btn{
    margin-left: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/common/LapUploadFile.vue